module.exports = "/static/assets/59b0fbbfc11533a02717aa7272b664f2.png";